<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  subjects: {
    type: Array,
    required: true,
  },
  loading: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['edit', 'delete']);
</script>

<template>
  <tbody
    class="divide-y divide-slate-50 dark:divide-slate-800 text-slate-700 dark:text-slate-300"
  >
    <tr v-for="(subject, index) in subjects" :key="index">
      <td
        class="max-w-xs py-4 pr-4 font-medium truncate align-baseline"
        :title="subject.name"
      >
        {{ subject.name }}
      </td>
      <td class="flex justify-end gap-1 py-4">
        <NextButton
          v-tooltip.top="$t('CONVERSATION_RESOLUTION_SUBJECT.EDIT.BUTTON_TEXT')"
          faded
          slate
          xs
          icon="i-lucide-pencil"
          data-testid="edit-subject"
          @click="emit('edit', subject)"
        />
        <NextButton
          v-tooltip.top="
            $t('CONVERSATION_RESOLUTION_SUBJECT.DELETE.BUTTON_TEXT')
          "
          faded
          ruby
          xs
          icon="i-lucide-circle-x"
          data-testid="delete-subject"
          :is-loading="loading[subject.id]"
          @click="emit('delete', subject)"
        />
      </td>
    </tr>
  </tbody>
</template>
